import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-collapse'

import { Testable } from '@cred/react-testable'
import { Disclosure } from '@cred/react-disclosures-sdk'
import { collapsibleClick } from '@cred/react-analytics/events'
import { Link as NoAnalyticsLink } from '@cred/react-link'

import FooterLinks, { Divider } from 'components/footer-links'

import styles from '../styles.modue.scss'

const StudentLoanCombinedFooter = ({
  showDisclosure,
  trackSnowplowEvent,
  wrapperClassName,
  linkClassName,
}) => {
  const [isOpen, setOpen] = useState(false)
  const iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'
  const toggleLenderList = () => {
    setOpen(!isOpen)

    trackSnowplowEvent(collapsibleClick, {
      text: 'Disclosures',
      action: isOpen ? 'collapse' : 'expand',
    })
  }
  return (
    <div className={wrapperClassName}>
      <Testable className={styles.container} testId="footer">
        <FooterLinks
          dividerClassName="ml-8 mr-8"
          showAdvertiserDisclosure={showDisclosure}
          linkClassName={linkClassName}
        >
          <>
            <Divider className="ml-8 mr-8" />
            <NoAnalyticsLink
              data-for="disclosures"
              className={`${styles.link} ${linkClassName} disclaimer`}
              onClick={toggleLenderList}
            >
              Disclosures <span className={`cred-icon ${iconClass} ${styles.iconStyle}`} />
            </NoAnalyticsLink>
          </>
        </FooterLinks>
      </Testable>

      <Collapse isOpened={isOpen}>
        <div className="neutral500 bodySmall">
          <Disclosure required={false} slug="inschool.landing.footer" />
        </div>
      </Collapse>
    </div>
  )
}

StudentLoanCombinedFooter.propTypes = {
  linkClassName: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string.isRequired,
  showDisclosure: PropTypes.bool.isRequired,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

export default StudentLoanCombinedFooter
